import {
  styled,
  StyledDermoIcon,
  breakpoints,
  theme,
} from '@notino/react-styleguide';

export const DermoIcon = styled(StyledDermoIcon)`
  width: 3.5rem;
  height: 3.5rem;

  ${theme.typography.labelSmall400};
  font-weight: 500;

  @media (min-width: ${breakpoints.md}) {
    width: 4rem;
    height: 4rem;
  }
`;
